import { PaymentMethod } from '../../../../../../../../../../../services/exports/Constants';

export default {
  title: 'Betaalmethoden',
  payment_options: {
    [PaymentMethod.Card]: 'Creditcard',
  },
};
